import {
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  TextField,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import { _helperIBaseResponse } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";

//Tipo 01 : Grupo
//Tipo 02 : Subgrupo

interface IPanelEditarSubGrupo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  archivoId: string;
  nombre: string;
  tipo: "01" | "02";
}

export interface IEditarSubgrupo {
  archivoId: string;
  nombre: string;
  tipo: string;
}

export const PanelEditarSubGrupo = (props: IPanelEditarSubGrupo) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [data, setdata] = useState<IEditarSubgrupo>({
    archivoId: "",
    nombre: "",
    tipo: "",
  });
  const [name, setName] = useState<string>("");

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      setdata({
        ...data,
        nombre: props.nombre,
        archivoId: props.archivoId,
        tipo: props.tipo,
      });
      setName(props.nombre);
      validarForm();
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [data]);

  const validarForm = () => {
    if (data == null) setDisableForm(true);
    if (data !== null) {
      if (data.archivoId && data.archivoId && data.nombre != name) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            {props.tipo == "01" ? "Actualizar Grupo" : "Actualizar SubGrupo"}
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    []
  );

  const _confirmar = () => {
    if (props.archivoId) {
      setIsSend(true);
      setDisableForm(true);
      setIsContenedor(true);
      grupoDocumentoService
        .editarGrupoDocumento(data)
        .then((res) => {
          if (res.status === 200) {
            setIsSend(false);
            if (res.data.confirmacion) {
              setIsSaccesfull(true);
              setMensaje(res.data.mensaje);
              props.onRenderTable();
              setdata({ ...data, archivoId: "", nombre: "" });
              setName("");

              //Clone Panel after one second
              setTimeout(() => {
                _goback();
              }, 1000);
            } else {
              setIsError(true);
              setMensajeError(res.data.mensaje);
            }
          }
        })
        .catch((err: Error) => {
          setIsSend(false);
          setIsError(true);
          setMensajeError(
            props.tipo == "01"
              ? "No se puedo Actualizar el Grupo"
              : "No se pudo actualizar el Subgrupo"
          );
        });
    }
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Actualizar"
          texto2={"Cancelar"}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
          disableButton={disableForm}
        />
      </>
    ),
    [props.onDismiss, validarForm, _confirmar]
  );

  const onChange = (e: any, datos: string | undefined) => {
    if (datos != undefined && datos != null) {
      setdata({ ...data, nombre: datos });
    }
  };

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setdata({ ...data, nombre: "" });
    setName("");
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        <br />
        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}

        <div hidden={isContenedor}>
          <TextField
            onChange={onChange}
            value={data.nombre}
            label="Nombre"
            required
            placeholder="Ingrese el nombre"
          />
        </div>
      </>
    </Panel>
  );
};
